export const languages = [
    {
        title: 'ID',
        value: 'id',
        image: 'assets/images/logo-id.png'
    },
    {
        title: 'EN',
        value: 'en',
        image: 'assets/images/logo-en.png'
    }
]